import { ReactSdkContext } from 'launchdarkly-react-client-sdk';
import React from 'react';

const LaunchDarklyContext = React.createContext<ReactSdkContext>(
  {} as ReactSdkContext,
);

export default LaunchDarklyContext;
